<div class="app-horizontal-nav-wrapper">
  @for (item of navigation; track trackByFn($index, item)) {
    @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
      @if (item.type === 'basic') {
        <app-horizontal-nav-basic-item class="app-horizontal-nav-menu-item" [item]="item" [name]="name" />
      }
      @if (item.type === 'aside' || item.type === 'collapsable' || item.type === 'group') {
        <app-horizontal-nav-branch-item class="app-horizontal-nav-menu-item" [item]="item" [name]="name" />
      }
      @if (item.type === 'spacer') {
        <app-horizontal-nav-spacer-item class="app-horizontal-nav-menu-item" [item]="item" />
      }
    }
  }
</div>
